<template>
  <div class="scroll-wrapper">
    <p class="scroll-text">
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["lang"],

  data() {
    return {
      text: ""
    }
  },

  watch: {
    lang: {
      immediate: true,
      handler(v) {
        if (v === "id") {
          this.text = "✨ Penawaran Eksklusif Untuk Kamu! ✨"
        } else {
          this.text = "✨ Exclusive Offers for You! ✨"
        }
      }
    }
  }
}
</script>

<style scoped>
.scroll-wrapper {
  text-align: center;
  margin-top: 30px;
}

.scroll-text {
  font-size: 20px;
  font-weight: bold;
  color: #594c65;
  animation: floatText 4s ease-in-out infinite;
}

@keyframes floatText {
  0%,100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}
</style>
